import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { COLUMNS } from "./constants";
import './index.scss';
import _ from '../../../i18n';
import lodash from 'lodash';
import { useSelector } from "react-redux";
import { formatAmount, parsePreference } from "../../../utils";
import CroissanceFilters from "../Components/CroissanceFilters/CroissanceFilters";
import { getReviewData } from "../../../api";
import InOutClientsChart from "./Charts/InOutClientsChart";
import CAEvolutionChart from "./Charts/CAEvolutionChart";
import DepartureCausesPieChart from "./Charts/DepartureCausesPieChart";
import RecuperationChart from "./Charts/RecuperationChart";
import { useQuery } from "react-query";
import moment from "moment";
import 'moment/locale/fr';
import { Input } from "antd";
import { Button } from "primereact/button";
import AnimatedLoadingIcon from "../../common/Icons/AnimatedLoadingIcon";

moment.locale('fr');

export default function CroissanceReviewPage({
  changeSelectedYear,
  collaborator,
  preferences
}) {
  const { token, navCommunity, user } = useSelector((state) => state.auth);
  const [reviewData, setReviewData] = useState([]);
  const [perMonthsData, setPerMonthsData] = useState([]);
  const [newOldPerMonthsData, setNewOldPerMonthsData] = useState([]);
  const [caEvolutionData, setCAEvolutionData] = useState([]);
  const [oldClientsPerReasonForLeaving, setOldClientsPerReasonForLeaving] = useState([]);
  const [recuperationData, setRecuperationData] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [displayedData, setDisplayedData] = useState([]);
  const [modifiedRows, setModifiedRows] = useState([]);
  const [showDetailsDatatable, setShowDetailsDatatable] = useState(false);
  const [isSaving, setIsSaving] = useState({
    comment: false,
    rowData: false
  });
  const formattedData = [];

  const [filters, setFilters] = useState({
    keyWord: "",
    clientGroup: [
      "Sociétés",
      "Indépendants",
      "Partenaire",
      "Particuliers",
      "Gérants",
      "Sociétés - Partenaire",
      "ASBL",
      "Indépendants petite entreprise",
      "AiSBL",
      "ASBL - Consultation",
      "Particuliers - Consultation",
      "Contact",
      "Gérant petite entreprise",
      "Indépendants - Consultation",
      "ASBL - Partenaire",
      "ASBL petite entreprise",
      "Fondation privée",
      "Sociétés petite entreprise",
    ],
    bu: parsePreference(preferences.financial).croissance.allowViewDataBy === 100 &&
      collaborator
        ? [collaborator.bu]
        : [],
    zone: parsePreference(preferences.financial).croissance.allowViewDataBy === 101 &&
      collaborator
        ? collaborator.zoneId
        : null,
    partner:
      parsePreference(preferences.financial).croissance.allowViewDataBy === 11
        ? user?.id
        : null,
    collaborator: [10, 100, 101, 110].includes(
      parsePreference(preferences.financial).croissance.allowViewDataBy
    ) && collaborator
      ? Number(collaborator.id)
      : null,
    role: null,
    year: new Date().getFullYear().toString(),
  });

  const getReviewDataQuery = useQuery(
    ["getReviewData", token, navCommunity, filters],
    async () => {
      const allowViewDataBy = parsePreference(
        preferences.financial
      ).croissance.allowViewDataBy;
      if (
        [10, 110].includes(allowViewDataBy) &&
        (!filters || !filters.collaborator)
      ) {
        setIsLoadingData(false);
        setReviewData([]);
        setDisplayedData([]);
        return [];
      } else if (token && navCommunity) {
        setIsLoadingData(true);
        try {
          const response = await getReviewData({
            token,
            organizationId: navCommunity.id,
            filters
          });
          let reviewData = response.data.data.review;
          const oldPerReasonForLeaving = response.data.data.perReasonForLeaving;
          let oldPerMonthsData = response.data.data.perMonths.old;
          let newPerMonthsData = response.data.data.perMonths.new;
          let recoverdPerMonthsData = response.data.data.perMonths.recovered;
          let temp = [];

          setReviewData(reviewData);
          console.log({ reviewData });
          setDisplayedData(reviewData);

          setOldClientsPerReasonForLeaving(oldPerReasonForLeaving);

          temp = [];
          temp.push({
            year: "N-1",
            new: reviewData[1].previousYearCA,
            followup: reviewData[2].previousYearCA,
            leaving: reviewData[3].previousYearCA,
            recovered: reviewData[4].previousYearCA,
            old: reviewData[5].previousYearCA,
          });
          temp.push({
            year: "N",
            new: reviewData[1].currentYearCA,
            followup: reviewData[2].currentYearCA,
            leaving: reviewData[3].currentYearCA,
            recovered: reviewData[4].currentYearCA,
            old: reviewData[5].currentYearCA,
          });
          temp.push({
            year: "N+1",
            new: reviewData[1].nextYearCA,
            followup: reviewData[2].nextYearCA,
            leaving: reviewData[3].nextYearCA,
            recovered: reviewData[4].nextYearCA,
            old: reviewData[5].nextYearCA,
          });

          setCAEvolutionData(temp);

          temp = [];
          for (let i = 0; i < 12; i++) {
            temp.push({
              month: moment().month(i).format('MMM'),
              old: oldPerMonthsData[i]?.total ? parseInt(oldPerMonthsData[i].total) : 0,
              new: newPerMonthsData[i]?.total ? parseInt(newPerMonthsData[i].total) : 0
            });
          }
          setNewOldPerMonthsData(temp);

          temp = [];
          for (let i = 0; i < 12; i++) {
            const oldValue = oldPerMonthsData[i]?.total ? parseInt(oldPerMonthsData[i].total) : 0;
            const recoveredValue = recoverdPerMonthsData[i]?.total ? parseInt(recoverdPerMonthsData[i].total) : 0;
            temp.push({
              month: moment().month(i).format('MMM'),
              old: oldValue,
              recovered: recoveredValue,
              ratio: oldValue === 0 ? 0 : (recoveredValue * 100) / oldValue,
            });
          }
          setRecuperationData(temp);

          setPerMonthsData(perMonthsData);
        } catch (e) {
          console.error("Error while fetching review data.", {e})
          return null;
        } finally {
          setIsLoadingData(false);
        }
      }
    }
  );

  useEffect(() => {
    COLUMNS.forEach((col) => {
      if (col.field === 'category') {
        col.body = categoryColumnBodyTemplate;
      } if (col.field === 'total') {
        col.body = totalColumnBodyTemplate;
      } else if (['previousYearCA', 'currentYearCA', 'nextYearCA'].includes(col.field)) {
        col.body = amountColumnBodyTemplate;
      } else if (col.field === 'comment') {
        col.body = commentColumnBodyTemplate;
      }
    });
  }, []);

  const categoryColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return '--';

    return (
      <div className="client-name-cell">
        <span className="client-name">{rowData.category}</span>
      </div>
    )
  };

  const totalColumnBodyTemplate = (rowData, args) => {
    if (rowData.totalValueType === 'count') {
      return <span><b>{rowData.total}</b> {(rowData.total > 1 ? 'clients' : 'client')}</span>
    } else if (rowData.totalValueType === 'amount') {
      if (rowData.category === 'Impact net (N)') {
        return (rowData.total > 0 ? '+' : '') + formatAmount(rowData.total);
      }
      return formatAmount(rowData.total);
    } else if (rowData.totalValueType === 'percentage') {
      return rowData.total.toFixed(0) + '%';
    }

    return rowData.total;
  };

  const amountColumnBodyTemplate = (rowData, args) => {
    if (rowData[args.field] === null) return '--';

    return (<div>{formatAmount(rowData[args.field])}</div>);
  };

  const commentColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);

    const fieldValue = rowData[args.field];

    return (
      <div className="cell-input-field">
        <Input.TextArea
          className={`input`}
          value={fieldValue}
          name={args.field}
          autoSize={{ minRows: 1, maxRows: 6 }}
          onChange={(e) => {
            handleRowModification(rowData, args.field, e.target.value);
          }}
        />
      </div>
    );
  }

  const actionsColumnBodyTemplate = (rowData) => {
    switch(rowData.id) {
      case 1: return (<div>(à intégrer une fois dispo)</div>)
      case 2: return (<div>Volume & CA gagnés</div>)
      case 3: return (<div>Risque de perte</div>)
      case 4: return (<div>Taux de récupération</div>)
      case 5: return (<div>Voir colonne « client récupéré »</div>)
      case 6: return (<div>Motifs de départ</div>)
      case 7: return (<div>ID clients sans GD</div>)
      case 8: return (<div>Depuis le tableau Entrants</div>)
      case 9: return (<div>Clients gagnés - sortis</div>)
      case 10: return (<div>(à intégrer une fois le tableau prospect dispo)</div>)
      default: return (<span>--</span>)
    }
  };

  const handleRowModification = (rowData, modifiedPropertyName, modifiedPropertyValue) => {
    const keys = modifiedPropertyName.split('.');
    const updatedRowData = {
      ...rowData,
      [modifiedPropertyName]: modifiedPropertyValue
    };

    // Set the new value in the cloned rowData
    setValue({ ...rowData }, keys, modifiedPropertyValue);

    // Update the modifiedRows state

    setModifiedRows(prevState => {
      // Check if the row already exists in modifiedRows
      const modifiedRowIndex = prevState.findIndex(i => i.id === rowData.id);

      if (modifiedRowIndex > -1) {
        // Update existing modified row
        const updatedModifiedRows = [...prevState];
        updatedModifiedRows[modifiedRowIndex] = { ...updatedModifiedRows[modifiedRowIndex], ...updatedRowData };
        return updatedModifiedRows;
      } else {
        // Add new modified row
        return [...prevState, updatedRowData];
      }
    });

    // Update the displayedData state
    setDisplayedData(prevState =>
      prevState.map(i =>
        i.id === rowData.id ? { ...rowData, [modifiedPropertyName]: modifiedPropertyValue } : i
      )
    );
  };

  const setValue = (obj, keys, value) => {
    keys.reduce((accumulator, key, index) => {
      // If we're at the last key, set the value
      if (index === keys.length - 1) {
        accumulator[key] = value;
      } else {
        // If the key doesn't exist, create an empty object
        if (!accumulator[key]) {
          accumulator[key] = {};
        }
        return accumulator[key]; // Move to the next nested object
      }
      return accumulator;
    }, obj);
  };

  const handleSaveModifiedRows = () => {
    setIsSaving(prevState => ({...prevState, rowData: true}));

    // saveRiskyClients({token, organizationId: navCommunity.id, items: modifiedRows}).then((res) => {
    //   if (res.status === 200) {
    //     setModifiedRows([]);
    //     toast.success("Les données ont été enregistrées avec succès");
    //     getReviewDataQuery.refetch();
    //   } else {
    //     toast.error("Une erreur est survenue lors de l'enregistrement des données");
    //   }
    // }).catch(e => {
    //   toast.error("Une erreur est survenue lors de l'enregistrement des données");
    //   console.error("Error saving data : ", e);
    // }).finally(() => {
    //   setIsSaving(prevState => ({...prevState, rowData: false}));
    // });

    setIsSaving(prevState => ({...prevState, rowData: false}));
  }

  const renderTotalCardsContent = () => {
    const formattedData = [
      {
        name: 'Croissance Nette',
        total: formatAmount(displayedData[7]['total']),
        children: [
          {
            label: 'Entrants',
            name: 'newClientsCA',
            value: formatAmount(displayedData[1]['currentYearCA']),
          },
          {
            label: 'Sortant',
            name: 'oldClientsCA',
            value: formatAmount(displayedData[5]['currentYearCA']),
          }
        ],
      },
      {
        name: 'Clients à suivre',
        total: displayedData[2]['total'],
        children: [
          {
            label: "Chiffre d'affaire",
            name: 'fllowupClientsCA',
            value: formatAmount(displayedData[2]['currentYearCA']),
          }
        ],
      },
      {
        name: 'Les clients non attribués',
        total: displayedData[6]['total'],
      },
    ];
    return (
      <div>
        <div className="financial-card-row">
          {formattedData &&
            formattedData.map((item, index) => {
              return (
                <div className="card-item" key={`${index}-${item.name}`}>
                  <div className="card-body">
                    <h5 className="card-title">{item?.name}</h5>
                    <div className="card-text">
                      {item.total}
                      <span className="text">{_("total")}</span>
                    </div>
                    {item?.children ? (
                      <div className="sub">
                        {item?.children.map((child, index) => {
                          return (
                            <div key={`${index}-${child.name}`}>
                              <p className="card-text small">{child.label}</p>
                              <span>
                                {child.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  return (
    <div className="review-container">
       <div className="datatable-header">
        <div className="datatable-header-row">
          <div className="filters" style={{display: "flex", gap: "8px"}}>
            <CroissanceFilters
              filterFormIsVisible={false}
              filter={filters}
              updateFilter={setFilters}
              fetching={getReviewDataQuery.isFetching}
              collaborator={collaborator}
              preferences={preferences}
              displaySearchBox={false}
              displayPageSizeSelect={false}
            />
          </div>
        </div>
      </div>


      {getReviewDataQuery.isFetching ? (
        <div className="ripple_loading" style={{alignItems: 'center'}}>
          <img src={"/img/Ripple-1s-150px.svg"} alt="" width={80} height={80} />
        </div>
      ) : (
        <>
          <div>
            {renderTotalCardsContent()}
            <div
              className="review_view_more_details_text"
              onClick={() => setShowDetailsDatatable(ps => !ps)}
            >
              {showDetailsDatatable ? 'Cacher les détails' : 'Voir plus de détails'}
            </div>
          </div>

          {showDetailsDatatable && (
            <DataTable
              value={displayedData}
              lazy
              // paginator
              totalRecords={reviewData.length}
              // rows={filters.pageSize}
              rowClassName="review-datatable-row"
              tableClassName="review-datatable"
              loading={isLoadingData}
              loadingIcon={
                <div className="ripple_loading" style={{alignItems: 'center'}}>
                  <img src={"/img/Ripple-1s-150px.svg"} alt="" width={80} height={80} />
                </div>
              }
            >
              {
                COLUMNS.map(col => (
                  <Column
                    className="datatable-column"
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    style={{width: col.style?.width ?? 'auto'}}
                    sortable={col.sortable ?? false}
                    body={col.body ?? null}
                    alignHeader={col?.alignHeader ?? 'left'}
                    resizeable={col?.resizeable ?? false}
                    align={col?.align ?? 'center'}
                  />
                ))
              }
            </DataTable>
          )}

          <section className="review-charts">
            <div className="card">
              <h5 className="card_title">Clients Entrants vs Sortants (par mois)</h5>
              <InOutClientsChart data={newOldPerMonthsData} />
            </div>
            <div className="card">
              <h5 className="card_title">Évolution du CA (Année N / N+1 / N-1)</h5>
              <CAEvolutionChart data={caEvolutionData} />
            </div>
            <div className="card">
              <h5 className="card_title">Répartition des causes de départ (total {oldClientsPerReasonForLeaving.reduce((sum, val) => sum + parseInt(val.total), 0)} clients)</h5>
              <DepartureCausesPieChart data={oldClientsPerReasonForLeaving} />
            </div>
            <div className="card">
              <h5 className="card_title">Taux de récupération des clients en partance</h5>
              <RecuperationChart data={recuperationData} />
            </div>
          </section>

          {/* save/cancel buttons */}
          {modifiedRows.length > 0 && (
            <div className="action-buttons">
              <Button
                label="Annuler"
                severity="secondary"
                size="small"
                onClick={() => {
                  setModifiedRows([]);
                  setDisplayedData(lodash.cloneDeep(reviewData));
                }}
                disabled={isSaving.rowData}
              />
              <Button
                size="small"
                label={
                  isSaving.rowData ? (
                    <AnimatedLoadingIcon color="#ffffff" />
                  ) : 'Enregistrer'
                }
                disabled={isSaving.rowData}
                severity="success"
                onClick={handleSaveModifiedRows}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}
